import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ProfileBanner from "../../components/public/Search/ProfileBanner";
import EmptySearch from "../../components/public/Search/EmptySearch";
import BusinessProfileWidget from "../../components/public/Search/BusinesProfileWidget";
import Search from "../../components/public/Search";
import {
  setSearchResults,
  setSearchCount,
} from "../../store/search/searchSlice";
import { SearchResults } from "../../components/public/Search/SearchResults";
import { LoadingIcon } from "../../components/common";
import Breadcrumb from "../../components/public/Breadcrumbs";
import { NotFoundCompany } from "./NotFoundCompany";
import useSearchCompany from "../../Hooks/useSearchCompany";
import { ReactComponent as Warning } from "../../assets/icons/Warning.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import GptPrompt from "../../components/public/Home/GptPrompt";


export default function SearchPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isPrompt = location.pathname.includes("prompt")
  const [banner, setBanner] = useState(true);
  const {
    searchQuery,
    searchResults,
    searchCount,
    worldBoxToken,
    countryData,
  } = useSelector((state) => state.search);

  const { token } = useSelector((state) => state.auth);
  const [page, setPage] = useState(1);
  const [showPrompt, setShowPrompt] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState({});

  const { data, isLoading, error, message, refetch } = useSearchCompany(
    searchQuery,
    countryData?.code,
    token,
    worldBoxToken,
    true,
    isPrompt,
    page
  );
  useEffect(() => {
    localStorage.removeItem("fromFooter")
    if (data) {
      dispatch(setSearchResults(isPrompt ? data?.results ?? [] : data));
      dispatch(setSearchCount(isPrompt ? data?.count : data?.length));
    }
  }, [data, dispatch, data?.results]);

  function scrollToHeight(height) {
    window.scrollTo({
      top: height,
      behavior: 'smooth' // Smooth scrolling animation
    });
  }

  useEffect(()=>{
    isPrompt && scrollToHeight(340)
  },[isPrompt])


  useMemo(() => {
    refetch();
  }, [page])

  const promptCrumbs = [{ label: "Home", url: "/gpt-prompts/access" }, { label: "Search Result", url: "/gpt-prompts/search" }];
  const promptResultCrumbs = [{ label: "Home", url: "/gpt-prompts/access" }, { label: "Search Result", click: () => setShowPrompt(false) }, { label: "Prompt Details" }];


  return (
    <>
      <div
        className={`mx-auto bg-slate ${isPrompt ? "px-0" : "px-4 lg:px-8 py-6"} w-full`}
        id="top"
      >
        {!isPrompt && <Breadcrumb skipPath={isPrompt && promptCrumbs} />}
        <div className={`grid md:grid-cols-4 lg:gap-4 md:gap-4 sm:gap-0 mb-4 grid-cols-1 ${isPrompt ? "w-full bg-white" : "max-w-7xl"} mx-auto`}>
          <div className={`${isPrompt ? "col-span-4 mt-0" : "col-span-3 mt-[-4%]"}`}>
            <div className={isPrompt && "bg-prompt-whiteXLLand-bg object-cover bg-cover w-full border h-[504px] flex flex-col justify-center items-center"}>
              {isPrompt && <h1 style={{ fontSize: "50px", color: "#012234" }} className="leading-tight max-w-3xl mx-auto font-bold text-white text-f32 font-sans lg:text-f62 line-1 md:text-f32">
                <p className="text-[#012234]">Unleash GPT's Full Potential with <span className="text-[#FF9700]">Ready-Made Prompts</span></p>
              </h1>}
              <div className={`${banner ? "mt-10" : ""} ${isPrompt ? "w-full" : ""}`}>
                <Search isLoading={isLoading} prompt={isPrompt} setShowPrompt={setShowPrompt} showPrompt={showPrompt} setSelectedPrompt={setSelectedPrompt} />
              </div>
            </div>
            <div className="mt-4">
              {isPrompt && <Breadcrumb skipPath={(isPrompt && !showPrompt) ? promptCrumbs : promptResultCrumbs} />}
            </div>
            {showPrompt ? <GptPrompt promptData={selectedPrompt} /> : <div className={isPrompt ? "w-full max-w-7xl mx-auto py-3" : ""}>
              <div>
                {searchResults?.length > 0 ? <div className="text-left mt-4 font-semibold">
                  Search Results ({searchCount})
                </div> : <div className="text-left mt-4 font-semibold"></div>}
                {!isPrompt && message !== "" && <div className="bg-warning border-warning border rounded-lg p-3 mb-5 text-left text-warning flex gap-3 items-center text-f12">
                  <Warning />
                  <span>
                    {message === 'error' ? <span>Technical issues may affect results. To access your company, <span className="underline cursor-pointer text-[#466483] font-bold" onClick={() => navigate('/create-company')}>Click here</span>. Otherwise, please try again later.</span> : " " + message}
                  </span>
                </div>}
              </div>
              {searchResults?.length === 0 && !isLoading && <EmptySearch searchEmptyText={error?.includes("WorldboxSearch returned too many hits") ? "Too many results. Please refine your company search." : (isPrompt && error) ? error.includes("Authentication credentials were not provided.") ? "You need to log in to access this functionality.": error : `No ${isPrompt ? "Prompt" : "Company"} matched your search`} prompt={isPrompt} />}

              {isLoading && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                  }}
                >
                  <LoadingIcon />
                </div>
              )}
              {searchResults?.length > 0 && <SearchResults data={searchResults} page={page} setPage={setPage} count={data?.count} setShowPrompt={setShowPrompt} showPrompt={showPrompt} setSelectedPrompt={setSelectedPrompt} />}
            </div>}
          </div>
          {!isPrompt && <div className="sidebar">
            <BusinessProfileWidget />
            <NotFoundCompany />
          </div>}
        </div>
      </div>
    </>
  );
}
